"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _ToggleMenu = _interopRequireDefault(require("./ToggleMenu"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VerticalTabs = _ref => {
  let {
    upperTabs,
    lowerTabs
  } = _ref;
  const classes = (0, _styles.useStyles)();
  const [open, setOpen] = _react.default.useState(false);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    variant: "permanent",
    classes: {
      paper: (0, _clsx.default)({
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open
      })
    }
  }, /*#__PURE__*/_react.default.createElement(_ToggleMenu.default, {
    classes: classes,
    isOpen: open,
    setIsOpen: setOpen
  }), /*#__PURE__*/_react.default.createElement(_List.default, {
    className: classes.list
  }, upperTabs.map(item => /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: !open ? item.title : "",
    key: item.title
  }, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    button: true,
    className: classes.listItem,
    onClick: item.onRowClick
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: item.href,
    target: item.openInNewTab ? "_blank" : "",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
    className: classes.listItemIcon
  }, item.icon), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    primary: item.title
  })))))), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement(_List.default, {
    className: classes.list
  }, lowerTabs.map(item => /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: !open ? item.title : "",
    key: item.title
  }, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    button: true,
    className: classes.listItem,
    onClick: item.onRowClick
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: item.href,
    target: item.openInNewTab ? "_blank" : "",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
    className: classes.listItemIcon
  }, item.icon), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    primary: item.title
  }))))))));
};
VerticalTabs.propTypes = {
  upperTabs: _propTypes.default.array,
  lowerTabs: _propTypes.default.array
};
var _default = exports.default = VerticalTabs;